import { render } from "./Icon.vue?vue&type=template&id=dff20c5c"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dff20c5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dff20c5c', __exports__)) {
    api.reload('dff20c5c', __exports__)
  }
  
  module.hot.accept("./Icon.vue?vue&type=template&id=dff20c5c", () => {
    api.rerender('dff20c5c', render)
  })

}


export default __exports__